export const FETCH_STATUS = {
  idle: "idle",
  loading: "loading",
  succeeded: "succeeded",
  failed: "failed",
};

export const COOKIE_CONSENT_COOKIE_NAME = 'hfaCookie';